import _ from 'lodash'

export function blobToBase64(blob) {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);

        reader.readAsDataURL(blob);
    });
}

export const randomLightToneColors = {
    a: "#9CDDDC",
    b: "#A4F144",
    c: "#58B7FA",
    d: "#3FE4A3 ",
    e: "#B5D54C ",
    f: "#AFE5FE",
    g: "#D9E082",
    h: "#76E7F7 ",
    i: "#08A092 ",
    j: "#047EE7",
    k: "#42F3AE",
    l: "#C2CF04",
    m: "#0BD2CB",
    n: "#7DFEF7",
    o: "#6CF0A5",
    p: "#FCEB50",
    q: "#CA88FC",
    r: "#D0CD72",
    s: "#E8C540",
    t: "#FFEEA6",
    u: "#89CDCC",
    v: "#AFF079",
    w: "#08ADC0",
    x: "#5ABCF4",
    y: "#9FD1A1",
    z: "#BECAE7",
};

export function isMenuInTheLowerPosition(menuElement, elementHeight) {
    if (!menuElement) return false;

    const windowHeight = window.innerHeight;
    const { bottom, top } = menuElement?.getBoundingClientRect();

    const spaceRequiredAtBottom = windowHeight - bottom;
    const spaceRequiredFromTop = windowHeight - top;

    const expandableFromBottom = spaceRequiredAtBottom >= elementHeight;
    const expandableFromTop = spaceRequiredFromTop >= elementHeight;

    if (!expandableFromBottom && expandableFromTop) {
        return true;
    }

    return !expandableFromBottom;
}
